import { render, staticRenderFns } from "./Borradores.vue?vue&type=template&id=2a5e103e&scoped=true&"
import script from "./Borradores.vue?vue&type=script&lang=js&"
export * from "./Borradores.vue?vue&type=script&lang=js&"
import style0 from "./Borradores.vue?vue&type=style&index=0&id=2a5e103e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5e103e",
  null
  
)

export default component.exports